/* eslint-disable import/no-duplicates */
/* eslint-disable @typescript-eslint/no-redeclare */

import React from 'react';
import { Tooltip as MuiTooltip } from '@mui/material';

import { ReactComponent as ChevronDown } from 'src/assets/img/icons/chevronDown.svg';
import { ReactComponent as SpaceDashboard } from 'src/assets/img/icons/space_dashboard.svg';
import { ReactComponent as Warehouse } from 'src/assets/img/icons/warehouse.svg';
import { ReactComponent as Inbound } from 'src/assets/img/icons/inbound.svg';
import { ReactComponent as Inventory2 } from 'src/assets/img/icons/inventory_2.svg';
import { ReactComponent as LocalShipping } from 'src/assets/img/icons/local_shipping.svg';
import { ReactComponent as Returns } from 'src/assets/img/icons/returns.svg';
import { ReactComponent as Account } from 'src/assets/img/icons/account.svg';
import { ReactComponent as BarChart } from 'src/assets/img/icons/bar_chart.svg';
import { ReactComponent as AccountTree } from 'src/assets/img/icons/account_tree.svg';
import { ReactComponent as Extension } from 'src/assets/img/icons/extension.svg';
import { ReactComponent as Notifications } from 'src/assets/img/icons/notifications.svg';
import { ReactComponent as LogoFullWhite } from 'src/assets/img/logo/full-white.svg';
import { ReactComponent as LogoFullDark } from 'src/assets/img/logo/full-dark.svg';
import { ReactComponent as LogoCompact } from 'src/assets/img/logo/compact.svg';
import { ReactComponent as LogoSquareDark } from 'src/assets/img/logo/square-dark.svg';
import { ReactComponent as LogoSquareLight } from 'src/assets/img/logo/square-light.svg';
import { ReactComponent as AccordionArrowUp } from 'src/assets/img/icons/accordion-arrow-up.svg';
import { ReactComponent as AccordionArrowDown } from 'src/assets/img/icons/accordion-arrow-down.svg';
import { ReactComponent as Download } from 'src/assets/img/icons/download.svg';
import { ReactComponent as Settings } from 'src/assets/img/icons/settings.svg';
import { ReactComponent as MoreHoriz } from 'src/assets/img/icons/more_horiz.svg';
import { ReactComponent as Star } from 'src/assets/img/icons/star.svg';
import { ReactComponent as Lightning } from 'src/assets/img/icons/lightning.svg';
import { ReactComponent as CalendarToday } from 'src/assets/img/icons/calendar_today.svg';
import { ReactComponent as Help } from 'src/assets/img/icons/help.svg';
import { ReactComponent as KeyboardTabToLeft } from 'src/assets/img/icons/keyboard_tab_rtl.svg';
import { ReactComponent as KeyboardTabToRight } from 'src/assets/img/icons/keyboard_tab.svg';
import { ReactComponent as Search } from 'src/assets/img/icons/search.svg';
import { ReactComponent as ArrowRight } from 'src/assets/img/icons/arrow_right_alt.svg';
import { ReactComponent as ArrowLeft } from 'src/assets/img/icons/arrow_left_alt.svg';
import { ReactComponent as ChevronLeft } from 'src/assets/img/icons/keyboard_arrow_left.svg';
import { ReactComponent as ChevronRight } from 'src/assets/img/icons/keyboard_arrow_right.svg';
import { ReactComponent as OpenInNew } from 'src/assets/img/icons/open_in_new.svg';
import { ReactComponent as Package } from 'src/assets/img/icons/package.svg';
import { ReactComponent as Warning } from 'src/assets/img/icons/warning.svg';
import { ReactComponent as Bug } from 'src/assets/img/icons/bug.svg';
import { ReactComponent as ArrowUpward } from 'src/assets/img/icons/arrow_upward.svg';
import { ReactComponent as ArrowDownward } from 'src/assets/img/icons/arrow_downward.svg';
import { ReactComponent as Tune } from 'src/assets/img/icons/tune.svg';
import { ReactComponent as DeleteWidget } from 'src/assets/img/icons/delete-widget.svg';
import { ReactComponent as DragIndicator } from 'src/assets/img/icons/drag_indicator.svg';
import { ReactComponent as Plus } from 'src/assets/img/icons/plus.svg';
import { ReactComponent as Send } from 'src/assets/img/icons/send.svg';
import { ReactComponent as SignPost } from 'src/assets/img/icons/signpost.svg';
import { ReactComponent as Close } from 'src/assets/img/icons/close.svg';
import { ReactComponent as Company } from 'src/assets/img/icons/apartment.svg';
import { ReactComponent as Profile } from 'src/assets/img/icons/profile.svg';
import { ReactComponent as Public } from 'src/assets/img/icons/public.svg';
import { ReactComponent as Channels } from 'src/assets/img/icons/channels.svg';
import { ReactComponent as Conditions } from 'src/assets/img/icons/conditions.svg';
import { ReactComponent as LogOut } from 'src/assets/img/icons/log_out.svg';
import { ReactComponent as DeleteCircle } from 'src/assets/img/icons/delete_circle.svg';
import { ReactComponent as Edit } from 'src/assets/img/icons/edit.svg';
import { ReactComponent as NotificationsActive } from 'src/assets/img/icons/notifications_active.svg';
import { ReactComponent as Duplicate } from 'src/assets/img/icons/content_copy.svg';
import { ReactComponent as StarFilled } from 'src/assets/img/icons/star_filled.svg';
import { ReactComponent as Delete } from 'src/assets/img/icons/delete.svg';
import { ReactComponent as StarDark } from 'src/assets/img/icons/starDark.svg';
import { ReactComponent as StarDarkFilled } from 'src/assets/img/icons/starFilledDark.svg';
import { ReactComponent as Variable } from 'src/assets/img/icons/variable.svg';
import { ReactComponent as Bold } from 'src/assets/img/icons/bold.svg';
import { ReactComponent as Italic } from 'src/assets/img/icons/italic.svg';
import { ReactComponent as Underline } from 'src/assets/img/icons/underline.svg';
import { ReactComponent as Apple } from 'src/assets/img/icons/apple.svg';
import { ReactComponent as Google } from 'src/assets/img/icons/google.svg';
import { ReactComponent as API } from 'src/assets/img/icons/api.svg';
import { ReactComponent as Checkmark } from 'src/assets/img/icons/checkmark.svg';
import { ReactComponent as CheckCircle } from 'src/assets/img/icons/check_circle.svg';
import { ReactComponent as Minus } from 'src/assets/img/icons/minus.svg';
import { ReactComponent as Error } from 'src/assets/img/icons/error.svg';
import { ReactComponent as Store } from 'src/assets/img/icons/store.svg';
import { ReactComponent as Fedex } from 'src/assets/img/icons/fedex.svg';
import { ReactComponent as Ups } from 'src/assets/img/icons/ups.svg';
import { ReactComponent as Dhl } from 'src/assets/img/icons/dhl.svg';
import { ReactComponent as Gls } from 'src/assets/img/icons/gls.svg';
import { ReactComponent as MyProfile } from 'src/assets/img/icons/my_profile.svg';
import { ReactComponent as Lock } from 'src/assets/img/icons/lock.svg';
import { ReactComponent as LockFilled } from 'src/assets/img/icons/lock-filled.svg';
import { ReactComponent as Eye } from 'src/assets/img/icons/eye.svg';
import { ReactComponent as Link } from 'src/assets/img/icons/link.svg';
import { ReactComponent as Integrations } from 'src/assets/img/icons/integrations.svg';
import { ReactComponent as ImageUpload } from 'src/assets/img/icons/image_upload.svg';
import { ReactComponent as InfoCircle } from 'src/assets/img/icons/info_circle.svg';
import { ReactComponent as InfoOutlined } from 'src/assets/img/icons/info_outlined.svg';
import { ReactComponent as AttachFile } from 'src/assets/img/icons/attach_file.svg';
import { ReactComponent as Pin } from 'src/assets/img/icons/pin.svg';
import { ReactComponent as Note } from 'src/assets/img/icons/note.svg';
import { ReactComponent as AiChat } from 'src/assets/img/icons/ai-chat.svg';
import { ReactComponent as Message } from 'src/assets/img/icons/message-icon.svg';
import { ReactComponent as VisibilityOff } from 'src/assets/img/icons/visibility_off.svg';

import { ReactComponent as FlagAbkhazia } from 'src/assets/img/countries/flag_abkhazia.svg';
import { ReactComponent as FlagGeorgia } from 'src/assets/img/countries/flag_georgia.svg';
import { ReactComponent as FlagOssetia } from 'src/assets/img/countries/flag_ossetia.svg';
import { ReactComponent as FlagAfghanistan } from 'src/assets/img/countries/flag_afghanistan.svg';
import { ReactComponent as FlagGermany } from 'src/assets/img/countries/flag_germany.svg';
import { ReactComponent as FlagPakistan } from 'src/assets/img/countries/flag_pakistan.svg';
import { ReactComponent as FlagAlandIslands } from 'src/assets/img/countries/flag_aland_islands.svg';
import { ReactComponent as FlagGhana } from 'src/assets/img/countries/flag_ghana.svg';
import { ReactComponent as FlagPalau } from 'src/assets/img/countries/flag_palau.svg';
import { ReactComponent as FlagAlbania } from 'src/assets/img/countries/flag_albania.svg';
import { ReactComponent as FlagGibraltar } from 'src/assets/img/countries/flag_gibraltar.svg';
import { ReactComponent as FlagPalestine } from 'src/assets/img/countries/flag_palestine.svg';
import { ReactComponent as FlagAlgeria } from 'src/assets/img/countries/flag_algeria.svg';
import { ReactComponent as FlagGreece } from 'src/assets/img/countries/flag_greece.svg';
import { ReactComponent as FlagPanama } from 'src/assets/img/countries/flag_panama.svg';
import { ReactComponent as FlagAmericanSamoa } from 'src/assets/img/countries/flag_american_samoa.svg';
import { ReactComponent as FlagGreenland } from 'src/assets/img/countries/flag_greenland.svg';
import { ReactComponent as FlagPapuaNewGuinea } from 'src/assets/img/countries/flag_papua_new_guinea.svg';
import { ReactComponent as FlagAndorra } from 'src/assets/img/countries/flag_andorra.svg';
import { ReactComponent as FlagGrenada } from 'src/assets/img/countries/flag_grenada.svg';
import { ReactComponent as FlagParaguay } from 'src/assets/img/countries/flag_paraguay.svg';
import { ReactComponent as FlagAngola } from 'src/assets/img/countries/flag_angola.svg';
import { ReactComponent as FlagGuam } from 'src/assets/img/countries/flag_guam.svg';
import { ReactComponent as FlagPeru } from 'src/assets/img/countries/flag_peru.svg';
import { ReactComponent as FlagAnguilla } from 'src/assets/img/countries/flag_anguilla.svg';
import { ReactComponent as FlagGuatemala } from 'src/assets/img/countries/flag_guatemala.svg';
import { ReactComponent as FlagPhilippines } from 'src/assets/img/countries/flag_philippines.svg';
import { ReactComponent as FlagAntiguaAndBarbuda } from 'src/assets/img/countries/flag_antigua_and_barbuda.svg';
import { ReactComponent as FlagGuernsey } from 'src/assets/img/countries/flag_guernsey.svg';
import { ReactComponent as FlagPitcairnIslands } from 'src/assets/img/countries/flag_pitcairn_islands.svg';
import { ReactComponent as FlagArgentina } from 'src/assets/img/countries/flag_argentina.svg';
import { ReactComponent as FlagGuinea } from 'src/assets/img/countries/flag_guinea.svg';
import { ReactComponent as FlagPoland } from 'src/assets/img/countries/flag_poland.svg';
import { ReactComponent as FlagArmenia } from 'src/assets/img/countries/flag_armenia.svg';
import { ReactComponent as FlagGuineaBissau } from 'src/assets/img/countries/flag_guinea_bissau.svg';
import { ReactComponent as FlagPortugal } from 'src/assets/img/countries/flag_portugal.svg';
import { ReactComponent as FlagAruba } from 'src/assets/img/countries/flag_aruba.svg';
import { ReactComponent as FlagGuyana } from 'src/assets/img/countries/flag_guyana.svg';
import { ReactComponent as FlagPuertoRico } from 'src/assets/img/countries/flag_puerto_rico.svg';
import { ReactComponent as FlagAustralia } from 'src/assets/img/countries/flag_australia.svg';
import { ReactComponent as FlagHaiti } from 'src/assets/img/countries/flag_haiti.svg';
import { ReactComponent as FlagQatar } from 'src/assets/img/countries/flag_qatar.svg';
import { ReactComponent as FlagAustria } from 'src/assets/img/countries/flag_austria.svg';
import { ReactComponent as FlagHawaii } from 'src/assets/img/countries/flag_hawaii.svg';
import { ReactComponent as FlagRapaNui } from 'src/assets/img/countries/flag_rapa_nui.svg';
import { ReactComponent as FlagAzerbaijan } from 'src/assets/img/countries/flag_azerbaijan.svg';
import { ReactComponent as FlagHonduras } from 'src/assets/img/countries/flag_honduras.svg';
import { ReactComponent as FlagRepublicOfMacedonia } from 'src/assets/img/countries/flag_republic_of_macedonia.svg';
import { ReactComponent as FlagAzoresIslands } from 'src/assets/img/countries/flag_azores_islands.svg';
import { ReactComponent as FlagHongKong } from 'src/assets/img/countries/flag_hong_kong.svg';
import { ReactComponent as FlagRepublicOfTheCongo } from 'src/assets/img/countries/flag_republic_of_the_congo.svg';
import { ReactComponent as FlagBahamas } from 'src/assets/img/countries/flag_bahamas.svg';
import { ReactComponent as FlagHungary } from 'src/assets/img/countries/flag_hungary.svg';
import { ReactComponent as FlagRomania } from 'src/assets/img/countries/flag_romania.svg';
import { ReactComponent as FlagBahrain } from 'src/assets/img/countries/flag_bahrain.svg';
import { ReactComponent as FlagIceland } from 'src/assets/img/countries/flag_iceland.svg';
import { ReactComponent as FlagRussia } from 'src/assets/img/countries/flag_russia.svg';
import { ReactComponent as FlagBalearicIslands } from 'src/assets/img/countries/flag_balearic_islands.svg';
import { ReactComponent as FlagIndia } from 'src/assets/img/countries/flag_india.svg';
import { ReactComponent as FlagRwanda } from 'src/assets/img/countries/flag_rwanda.svg';
import { ReactComponent as FlagBangladesh } from 'src/assets/img/countries/flag_bangladesh.svg';
import { ReactComponent as FlagIndonesia } from 'src/assets/img/countries/flag_indonesia.svg';
import { ReactComponent as FlagSabaIsland } from 'src/assets/img/countries/flag_saba_island.svg';
import { ReactComponent as FlagBarbados } from 'src/assets/img/countries/flag_barbados.svg';
import { ReactComponent as FlagIran } from 'src/assets/img/countries/flag_iran.svg';
import { ReactComponent as FlagSahrawiArabDemocraticRepublic } from 'src/assets/img/countries/flag_sahrawi_arab_democratic_republic.svg';
import { ReactComponent as FlagBasqueCountry } from 'src/assets/img/countries/flag_basque_country.svg';
import { ReactComponent as FlagIraq } from 'src/assets/img/countries/flag_iraq.svg';
import { ReactComponent as FlagSamoa } from 'src/assets/img/countries/flag_samoa.svg';
import { ReactComponent as FlagBelarus } from 'src/assets/img/countries/flag_belarus.svg';
import { ReactComponent as FlagIreland } from 'src/assets/img/countries/flag_ireland.svg';
import { ReactComponent as FlagSanMarino } from 'src/assets/img/countries/flag_san_marino.svg';
import { ReactComponent as FlagBelgium } from 'src/assets/img/countries/flag_belgium.svg';
import { ReactComponent as FlagIsleOfMan } from 'src/assets/img/countries/flag_isle_of_man.svg';
import { ReactComponent as FlagSaoTomeAndPrince } from 'src/assets/img/countries/flag_sao_tome_and_prince.svg';
import { ReactComponent as FlagBelize } from 'src/assets/img/countries/flag_belize.svg';
import { ReactComponent as FlagIsrael } from 'src/assets/img/countries/flag_israel.svg';
import { ReactComponent as FlagSardinia } from 'src/assets/img/countries/flag_sardinia.svg';
import { ReactComponent as FlagBenin } from 'src/assets/img/countries/flag_benin.svg';
import { ReactComponent as FlagItaly } from 'src/assets/img/countries/flag_italy.svg';
import { ReactComponent as FlagSaudiArabia } from 'src/assets/img/countries/flag_saudi_arabia.svg';
import { ReactComponent as FlagBermuda } from 'src/assets/img/countries/flag_bermuda.svg';
import { ReactComponent as FlagIvoryCoast } from 'src/assets/img/countries/flag_ivory_coast.svg';
import { ReactComponent as FlagScotland } from 'src/assets/img/countries/flag_scotland.svg';
import { ReactComponent as FlagBhutan } from 'src/assets/img/countries/flag_bhutan.svg';
import { ReactComponent as FlagJamaica } from 'src/assets/img/countries/flag_jamaica.svg';
import { ReactComponent as FlagSenegal } from 'src/assets/img/countries/flag_senegal.svg';
import { ReactComponent as FlagBolivia } from 'src/assets/img/countries/flag_bolivia.svg';
import { ReactComponent as FlagJapan } from 'src/assets/img/countries/flag_japan.svg';
import { ReactComponent as FlagSerbia } from 'src/assets/img/countries/flag_serbia.svg';
import { ReactComponent as FlagBonaire } from 'src/assets/img/countries/flag_bonaire.svg';
import { ReactComponent as FlagJersey } from 'src/assets/img/countries/flag_jersey.svg';
import { ReactComponent as FlagSeychelles } from 'src/assets/img/countries/flag_seychelles.svg';
import { ReactComponent as FlagBosniaAndHerzegovina } from 'src/assets/img/countries/flag_bosnia_and_herzegovina.svg';
import { ReactComponent as FlagJordan } from 'src/assets/img/countries/flag_jordan.svg';
import { ReactComponent as FlagSierraLeone } from 'src/assets/img/countries/flag_sierra_leone.svg';
import { ReactComponent as FlagBotswana } from 'src/assets/img/countries/flag_botswana.svg';
import { ReactComponent as FlagKazakhstan } from 'src/assets/img/countries/flag_kazakhstan.svg';
import { ReactComponent as FlagSingapore } from 'src/assets/img/countries/flag_singapore.svg';
import { ReactComponent as FlagBrazil } from 'src/assets/img/countries/flag_brazil.svg';
import { ReactComponent as FlagKenya } from 'src/assets/img/countries/flag_kenya.svg';
import { ReactComponent as FlagSintEustatius } from 'src/assets/img/countries/flag_sint_eustatius.svg';
import { ReactComponent as FlagBritishColumbia } from 'src/assets/img/countries/flag_british_columbia.svg';
import { ReactComponent as FlagKiribati } from 'src/assets/img/countries/flag_kiribati.svg';
import { ReactComponent as FlagSintMaarten } from 'src/assets/img/countries/flag_sint_maarten.svg';
import { ReactComponent as FlagBritishIndianOceanTerritory } from 'src/assets/img/countries/flag_british_indian_ocean_territory.svg';
import { ReactComponent as FlagKosovo } from 'src/assets/img/countries/flag_kosovo.svg';
import { ReactComponent as FlagSlovakia } from 'src/assets/img/countries/flag_slovakia.svg';
import { ReactComponent as FlagBritishVirginIslands } from 'src/assets/img/countries/flag_british_virgin_islands.svg';
import { ReactComponent as FlagKuwait } from 'src/assets/img/countries/flag_kuwait.svg';
import { ReactComponent as FlagSlovenia } from 'src/assets/img/countries/flag_slovenia.svg';
import { ReactComponent as FlagBrunei } from 'src/assets/img/countries/flag_brunei.svg';
import { ReactComponent as FlagKyrgyzstan } from 'src/assets/img/countries/flag_kyrgyzstan.svg';
import { ReactComponent as FlagSolomonIslands } from 'src/assets/img/countries/flag_solomon_islands.svg';
import { ReactComponent as FlagBulgaria } from 'src/assets/img/countries/flag_bulgaria.svg';
import { ReactComponent as FlagLaos } from 'src/assets/img/countries/flag_laos.svg';
import { ReactComponent as FlagSomalia } from 'src/assets/img/countries/flag_somalia.svg';
import { ReactComponent as FlagBurkinaFaso } from 'src/assets/img/countries/flag_burkina_faso.svg';
import { ReactComponent as FlagLatvia } from 'src/assets/img/countries/flag_latvia.svg';
import { ReactComponent as FlagSomaliland } from 'src/assets/img/countries/flag_somaliland.svg';
import { ReactComponent as FlagBurundi } from 'src/assets/img/countries/flag_burundi.svg';
import { ReactComponent as FlagLebanon } from 'src/assets/img/countries/flag_lebanon.svg';
import { ReactComponent as FlagSouthAfrica } from 'src/assets/img/countries/flag_south_africa.svg';
import { ReactComponent as FlagCambodia } from 'src/assets/img/countries/flag_cambodia.svg';
import { ReactComponent as FlagLesotho } from 'src/assets/img/countries/flag_lesotho.svg';
import { ReactComponent as FlagSouthKorea } from 'src/assets/img/countries/flag_south_korea.svg';
import { ReactComponent as FlagCameroon } from 'src/assets/img/countries/flag_cameroon.svg';
import { ReactComponent as FlagLiberia } from 'src/assets/img/countries/flag_liberia.svg';
import { ReactComponent as FlagSouthSudan } from 'src/assets/img/countries/flag_south_sudan.svg';
import { ReactComponent as FlagCanada } from 'src/assets/img/countries/flag_canada.svg';
import { ReactComponent as FlagLibya } from 'src/assets/img/countries/flag_libya.svg';
import { ReactComponent as FlagSpain } from 'src/assets/img/countries/flag_spain.svg';
import { ReactComponent as FlagCanaryIslands } from 'src/assets/img/countries/flag_canary_islands.svg';
import { ReactComponent as FlagLiechtenstein } from 'src/assets/img/countries/flag_liechtenstein.svg';
import { ReactComponent as FlagSriLanka } from 'src/assets/img/countries/flag_sri_lanka.svg';
import { ReactComponent as FlagCapeVerde } from 'src/assets/img/countries/flag_cape_verde.svg';
import { ReactComponent as FlagLithuania } from 'src/assets/img/countries/flag_lithuania.svg';
import { ReactComponent as FlagStBarts } from 'src/assets/img/countries/flag_st_barts.svg';
import { ReactComponent as FlagCaymanIslands } from 'src/assets/img/countries/flag_cayman_islands.svg';
import { ReactComponent as FlagLuxembourg } from 'src/assets/img/countries/flag_luxembourg.svg';
import { ReactComponent as FlagStLucia } from 'src/assets/img/countries/flag_st_lucia.svg';
import { ReactComponent as FlagCentralAfricanRepublic } from 'src/assets/img/countries/flag_central_african_republic.svg';
import { ReactComponent as FlagMacao } from 'src/assets/img/countries/flag_macao.svg';
import { ReactComponent as FlagStVincentAndTheGrenadines } from 'src/assets/img/countries/flag_st_vincent_and_the_grenadines.svg';
import { ReactComponent as FlagCeuta } from 'src/assets/img/countries/flag_ceuta.svg';
import { ReactComponent as FlagMadagascar } from 'src/assets/img/countries/flag_madagascar.svg';
import { ReactComponent as FlagSudan } from 'src/assets/img/countries/flag_sudan.svg';
import { ReactComponent as FlagChad } from 'src/assets/img/countries/flag_chad.svg';
import { ReactComponent as FlagMadeira } from 'src/assets/img/countries/flag_madeira.svg';
import { ReactComponent as FlagSuriname } from 'src/assets/img/countries/flag_suriname.svg';
import { ReactComponent as FlagChile } from 'src/assets/img/countries/flag_chile.svg';
import { ReactComponent as FlagMalawi } from 'src/assets/img/countries/flag_malawi.svg';
import { ReactComponent as FlagSwaziland } from 'src/assets/img/countries/flag_swaziland.svg';
import { ReactComponent as FlagChina } from 'src/assets/img/countries/flag_china.svg';
import { ReactComponent as FlagMalaysia } from 'src/assets/img/countries/flag_malaysia.svg';
import { ReactComponent as FlagSweden } from 'src/assets/img/countries/flag_sweden.svg';
import { ReactComponent as FlagCocosIsland } from 'src/assets/img/countries/flag_cocos_island.svg';
import { ReactComponent as FlagMaldives } from 'src/assets/img/countries/flag_maldives.svg';
import { ReactComponent as FlagSwitzerland } from 'src/assets/img/countries/flag_switzerland.svg';
import { ReactComponent as FlagColombia } from 'src/assets/img/countries/flag_colombia.svg';
import { ReactComponent as FlagMali } from 'src/assets/img/countries/flag_mali.svg';
import { ReactComponent as FlagSyria } from 'src/assets/img/countries/flag_syria.svg';
import { ReactComponent as FlagComoros } from 'src/assets/img/countries/flag_comoros.svg';
import { ReactComponent as FlagMalta } from 'src/assets/img/countries/flag_malta.svg';
import { ReactComponent as FlagTaiwan } from 'src/assets/img/countries/flag_taiwan.svg';
import { ReactComponent as FlagCookIslands } from 'src/assets/img/countries/flag_cook_islands.svg';
import { ReactComponent as FlagMarshallIsland } from 'src/assets/img/countries/flag_marshall_island.svg';
import { ReactComponent as FlagTajikistan } from 'src/assets/img/countries/flag_tajikistan.svg';
import { ReactComponent as FlagCorsica } from 'src/assets/img/countries/flag_corsica.svg';
import { ReactComponent as FlagMartinique } from 'src/assets/img/countries/flag_martinique.svg';
import { ReactComponent as FlagTanzania } from 'src/assets/img/countries/flag_tanzania.svg';
import { ReactComponent as FlagCostaRica } from 'src/assets/img/countries/flag_costa_rica.svg';
import { ReactComponent as FlagMauritania } from 'src/assets/img/countries/flag_mauritania.svg';
import { ReactComponent as FlagThailand } from 'src/assets/img/countries/flag_thailand.svg';
import { ReactComponent as FlagCroatia } from 'src/assets/img/countries/flag_croatia.svg';
import { ReactComponent as FlagMauritius } from 'src/assets/img/countries/flag_mauritius.svg';
import { ReactComponent as FlagTibet } from 'src/assets/img/countries/flag_tibet.svg';
import { ReactComponent as FlagCuba } from 'src/assets/img/countries/flag_cuba.svg';
import { ReactComponent as FlagMelilla } from 'src/assets/img/countries/flag_melilla.svg';
import { ReactComponent as FlagTogo } from 'src/assets/img/countries/flag_togo.svg';
import { ReactComponent as FlagCuracao } from 'src/assets/img/countries/flag_curacao.svg';
import { ReactComponent as FlagMexico } from 'src/assets/img/countries/flag_mexico.svg';
import { ReactComponent as FlagTokelau } from 'src/assets/img/countries/flag_tokelau.svg';
import { ReactComponent as FlagCyprus } from 'src/assets/img/countries/flag_cyprus.svg';
import { ReactComponent as FlagMicronesia } from 'src/assets/img/countries/flag_micronesia.svg';
import { ReactComponent as FlagTonga } from 'src/assets/img/countries/flag_tonga.svg';
import { ReactComponent as FlagCzechRepublic } from 'src/assets/img/countries/flag_czech_republic.svg';
import { ReactComponent as FlagMoldova } from 'src/assets/img/countries/flag_moldova.svg';
import { ReactComponent as FlagTransnistria } from 'src/assets/img/countries/flag_transnistria.svg';
import { ReactComponent as FlagDemocraticRepublicOfCongo } from 'src/assets/img/countries/flag_democratic_republic_of_congo.svg';
import { ReactComponent as FlagMonaco } from 'src/assets/img/countries/flag_monaco.svg';
import { ReactComponent as FlagTrinidadAndTobago } from 'src/assets/img/countries/flag_trinidad_and_tobago.svg';
import { ReactComponent as FlagDenmark } from 'src/assets/img/countries/flag_denmark.svg';
import { ReactComponent as FlagMongolia } from 'src/assets/img/countries/flag_mongolia.svg';
import { ReactComponent as FlagTunisia } from 'src/assets/img/countries/flag_tunisia.svg';
import { ReactComponent as FlagDjibouti } from 'src/assets/img/countries/flag_djibouti.svg';
import { ReactComponent as FlagMontenegro } from 'src/assets/img/countries/flag_montenegro.svg';
import { ReactComponent as FlagTurkey } from 'src/assets/img/countries/flag_turkey.svg';
import { ReactComponent as FlagDominica } from 'src/assets/img/countries/flag_dominica.svg';
import { ReactComponent as FlagMontserrat } from 'src/assets/img/countries/flag_montserrat.svg';
import { ReactComponent as FlagTurkmenistan } from 'src/assets/img/countries/flag_turkmenistan.svg';
import { ReactComponent as FlagDominicanRepublic } from 'src/assets/img/countries/flag_dominican_republic.svg';
import { ReactComponent as FlagMorocco } from 'src/assets/img/countries/flag_morocco.svg';
import { ReactComponent as FlagTurksAndCaicos } from 'src/assets/img/countries/flag_turks_and_caicos.svg';
import { ReactComponent as FlagEastTimor } from 'src/assets/img/countries/flag_east_timor.svg';
import { ReactComponent as FlagMozambique } from 'src/assets/img/countries/flag_mozambique.svg';
import { ReactComponent as FlagTuvalu } from 'src/assets/img/countries/flag_tuvalu.svg';
import { ReactComponent as FlagEcuador } from 'src/assets/img/countries/flag_ecuador.svg';
import { ReactComponent as FlagMyanmar } from 'src/assets/img/countries/flag_myanmar.svg';
import { ReactComponent as FlagUganda } from 'src/assets/img/countries/flag_uganda.svg';
import { ReactComponent as FlagEgypt } from 'src/assets/img/countries/flag_egypt.svg';
import { ReactComponent as FlagNamibia } from 'src/assets/img/countries/flag_namibia.svg';
import { ReactComponent as FlagUkraine } from 'src/assets/img/countries/flag_ukraine.svg';
import { ReactComponent as FlagElSalvador } from 'src/assets/img/countries/flag_el_salvador.svg';
import { ReactComponent as FlagNato } from 'src/assets/img/countries/flag_nato.svg';
import { ReactComponent as FlagUnitedArabEmirates } from 'src/assets/img/countries/flag_united_arab_emirates.svg';
import { ReactComponent as FlagEngland } from 'src/assets/img/countries/flag_england.svg';
import { ReactComponent as FlagNauru } from 'src/assets/img/countries/flag_nauru.svg';
import { ReactComponent as FlagUnitedKingdom } from 'src/assets/img/countries/flag_united_kingdom.svg';
import { ReactComponent as FlagEquatorialGuinea } from 'src/assets/img/countries/flag_equatorial_guinea.svg';
import { ReactComponent as FlagNepal } from 'src/assets/img/countries/flag_nepal.svg';
import { ReactComponent as FlagUnitedNations } from 'src/assets/img/countries/flag_united_nations.svg';
import { ReactComponent as FlagEritrea } from 'src/assets/img/countries/flag_eritrea.svg';
import { ReactComponent as FlagNetherlands } from 'src/assets/img/countries/flag_netherlands.svg';
import { ReactComponent as FlagUnitedStates } from 'src/assets/img/countries/flag_united_states.svg';
import { ReactComponent as FlagEstonia } from 'src/assets/img/countries/flag_estonia.svg';
import { ReactComponent as FlagNewZealand } from 'src/assets/img/countries/flag_new_zealand.svg';
import { ReactComponent as FlagUruguay } from 'src/assets/img/countries/flag_uruguay.svg';
import { ReactComponent as FlagEthiopia } from 'src/assets/img/countries/flag_ethiopia.svg';
import { ReactComponent as FlagNicaragua } from 'src/assets/img/countries/flag_nicaragua.svg';
import { ReactComponent as FlagUzbekistán } from 'src/assets/img/countries/flag_uzbekistán.svg';
import { ReactComponent as FlagEuropeanUnion } from 'src/assets/img/countries/flag_european_union.svg';
import { ReactComponent as FlagNiger } from 'src/assets/img/countries/flag_niger.svg';
import { ReactComponent as FlagVanuatu } from 'src/assets/img/countries/flag_vanuatu.svg';
import { ReactComponent as FlagFalklandIslands } from 'src/assets/img/countries/flag_falkland_islands.svg';
import { ReactComponent as FlagNigeria } from 'src/assets/img/countries/flag_nigeria.svg';
import { ReactComponent as FlagVaticanCity } from 'src/assets/img/countries/flag_vatican_city.svg';
import { ReactComponent as FlagFaroeIslands } from 'src/assets/img/countries/flag_faroe_islands.svg';
import { ReactComponent as FlagNiue } from 'src/assets/img/countries/flag_niue.svg';
import { ReactComponent as FlagVenezuela } from 'src/assets/img/countries/flag_venezuela.svg';
import { ReactComponent as FlagFiji } from 'src/assets/img/countries/flag_fiji.svg';
import { ReactComponent as FlagNorfolkIsland } from 'src/assets/img/countries/flag_norfolk_island.svg';
import { ReactComponent as FlagVietnam } from 'src/assets/img/countries/flag_vietnam.svg';
import { ReactComponent as FlagFinland } from 'src/assets/img/countries/flag_finland.svg';
import { ReactComponent as FlagNorthKorea } from 'src/assets/img/countries/flag_north_korea.svg';
import { ReactComponent as FlagVirginIslands } from 'src/assets/img/countries/flag_virgin_islands.svg';
import { ReactComponent as FlagFrance } from 'src/assets/img/countries/flag_france.svg';
import { ReactComponent as FlagNorthernCyprus } from 'src/assets/img/countries/flag_northern_cyprus.svg';
import { ReactComponent as FlagWales } from 'src/assets/img/countries/flag_wales.svg';
import { ReactComponent as FlagFrenchPolynesia } from 'src/assets/img/countries/flag_french_polynesia.svg';
import { ReactComponent as FlagNorthernMarianasIslands } from 'src/assets/img/countries/flag_northern_marianas_islands.svg';
import { ReactComponent as FlagYemen } from 'src/assets/img/countries/flag_yemen.svg';
import { ReactComponent as FlagGabon } from 'src/assets/img/countries/flag_gabon.svg';
import { ReactComponent as FlagNorway } from 'src/assets/img/countries/flag_norway.svg';
import { ReactComponent as FlagZambia } from 'src/assets/img/countries/flag_zambia.svg';
import { ReactComponent as FlagGalapagosIslands } from 'src/assets/img/countries/flag_galapagos_islands.svg';
import { ReactComponent as FlagOman } from 'src/assets/img/countries/flag_oman.svg';
import { ReactComponent as FlagZimbabwe } from 'src/assets/img/countries/flag_zimbabwe.svg';
import { ReactComponent as FlagGambia } from 'src/assets/img/countries/flag_gambia.svg';
import { ReactComponent as FlagOrkneyIslands } from 'src/assets/img/countries/flag_orkney_islands.svg';
import { ReactComponent as Chat } from 'src/assets/img/icons/chat.svg';
import { ReactComponent as Menu } from 'src/assets/img/icons/menu.svg';

import { ReactComponent as Facebook } from 'src/assets/img/icons/facebook.svg';
import { ReactComponent as LinkedIn } from 'src/assets/img/icons/linkedin.svg';
import { ReactComponent as X } from 'src/assets/img/icons/x.svg';
import { ReactComponent as File } from 'src/assets/img/icons/file.svg';
import { ReactComponent as Pallet } from 'src/assets/img/icons/pallet.svg';
import { ReactComponent as FolderOpen } from 'src/assets/img/icons/folder_open.svg';
import { ReactComponent as AccountCircle } from 'src/assets/img/icons/account_circle.svg';
import { ReactComponent as LabelImportant } from 'src/assets/img/icons/label_important.svg';
import { ReactComponent as CloudDownload } from 'src/assets/img/icons/cloud_download.svg';
import { ReactComponent as RunImport } from 'src/assets/img/icons/run_import.svg';
import { ReactComponent as WarningFilled } from 'src/assets/img/icons/warning_filled.svg';
import { Info } from '@mui/icons-material';

type IconProps = {
  className?: string;
  color?: string;
  iconRef?: React.Ref<HTMLDivElement>;
  name: IconName;
  width?: number;
  height?: number;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
  hoverText?: string | null;
};

export type IconName = keyof typeof iconComponents;

const iconFlags = {
  flagAbkhazia: FlagAbkhazia,
  flagGeorgia: FlagGeorgia,
  flagOssetia: FlagOssetia,
  flagAfghanistan: FlagAfghanistan,
  flagGermany: FlagGermany,
  flagPakistan: FlagPakistan,
  flagAlandIslands: FlagAlandIslands,
  flagGhana: FlagGhana,
  flagPalau: FlagPalau,
  flagAlbania: FlagAlbania,
  flagGibraltar: FlagGibraltar,
  flagPalestine: FlagPalestine,
  flagAlgeria: FlagAlgeria,
  flagGreece: FlagGreece,
  flagPanama: FlagPanama,
  flagAmericanSamoa: FlagAmericanSamoa,
  flagGreenland: FlagGreenland,
  flagPapuaNewGuinea: FlagPapuaNewGuinea,
  flagAndorra: FlagAndorra,
  flagGrenada: FlagGrenada,
  flagParaguay: FlagParaguay,
  flagAngola: FlagAngola,
  flagGuam: FlagGuam,
  flagPeru: FlagPeru,
  flagAnguilla: FlagAnguilla,
  flagGuatemala: FlagGuatemala,
  flagPhilippines: FlagPhilippines,
  flagAntiguaAndBarbuda: FlagAntiguaAndBarbuda,
  flagGuernsey: FlagGuernsey,
  flagPitcairnIslands: FlagPitcairnIslands,
  flagArgentina: FlagArgentina,
  flagGuinea: FlagGuinea,
  flagPoland: FlagPoland,
  flagArmenia: FlagArmenia,
  flagGuineaBissau: FlagGuineaBissau,
  flagPortugal: FlagPortugal,
  flagAruba: FlagAruba,
  flagGuyana: FlagGuyana,
  flagPuertoRico: FlagPuertoRico,
  flagAustralia: FlagAustralia,
  flagHaiti: FlagHaiti,
  flagQatar: FlagQatar,
  flagAustria: FlagAustria,
  flagHawaii: FlagHawaii,
  flagRapaNui: FlagRapaNui,
  flagAzerbaijan: FlagAzerbaijan,
  flagHonduras: FlagHonduras,
  flagRepublicOfMacedonia: FlagRepublicOfMacedonia,
  flagAzoresIslands: FlagAzoresIslands,
  flagHongKong: FlagHongKong,
  flagRepublicOfTheCongo: FlagRepublicOfTheCongo,
  flagBahamas: FlagBahamas,
  flagHungary: FlagHungary,
  flagRomania: FlagRomania,
  flagBahrain: FlagBahrain,
  flagIceland: FlagIceland,
  flagRussia: FlagRussia,
  flagBalearicIslands: FlagBalearicIslands,
  flagIndia: FlagIndia,
  flagRwanda: FlagRwanda,
  flagBangladesh: FlagBangladesh,
  flagIndonesia: FlagIndonesia,
  flagSabaIsland: FlagSabaIsland,
  flagBarbados: FlagBarbados,
  flagIran: FlagIran,
  flagSahrawiArabDemocraticRepublic: FlagSahrawiArabDemocraticRepublic,
  flagBasqueCountry: FlagBasqueCountry,
  flagIraq: FlagIraq,
  flagSamoa: FlagSamoa,
  flagBelarus: FlagBelarus,
  flagIreland: FlagIreland,
  flagSanMarino: FlagSanMarino,
  flagBelgium: FlagBelgium,
  flagIsleOfMan: FlagIsleOfMan,
  flagSaoTomeAndPrince: FlagSaoTomeAndPrince,
  flagBelize: FlagBelize,
  flagIsrael: FlagIsrael,
  flagSardinia: FlagSardinia,
  flagBenin: FlagBenin,
  flagItaly: FlagItaly,
  flagSaudiArabia: FlagSaudiArabia,
  flagBermuda: FlagBermuda,
  flagIvoryCoast: FlagIvoryCoast,
  flagScotland: FlagScotland,
  flagBhutan: FlagBhutan,
  flagJamaica: FlagJamaica,
  flagSenegal: FlagSenegal,
  flagBolivia: FlagBolivia,
  flagJapan: FlagJapan,
  flagSerbia: FlagSerbia,
  flagBonaire: FlagBonaire,
  flagJersey: FlagJersey,
  flagSeychelles: FlagSeychelles,
  flagBosniaAndHerzegovina: FlagBosniaAndHerzegovina,
  flagJordan: FlagJordan,
  flagSierraLeone: FlagSierraLeone,
  flagBotswana: FlagBotswana,
  flagKazakhstan: FlagKazakhstan,
  flagSingapore: FlagSingapore,
  flagBrazil: FlagBrazil,
  flagKenya: FlagKenya,
  flagSintEustatius: FlagSintEustatius,
  flagBritishColumbia: FlagBritishColumbia,
  flagKiribati: FlagKiribati,
  flagSintMaarten: FlagSintMaarten,
  flagBritishIndianOceanTerritory: FlagBritishIndianOceanTerritory,
  flagKosovo: FlagKosovo,
  flagSlovakia: FlagSlovakia,
  flagBritishVirginIslands: FlagBritishVirginIslands,
  flagKuwait: FlagKuwait,
  flagSlovenia: FlagSlovenia,
  flagBrunei: FlagBrunei,
  flagKyrgyzstan: FlagKyrgyzstan,
  flagSolomonIslands: FlagSolomonIslands,
  flagBulgaria: FlagBulgaria,
  flagLaos: FlagLaos,
  flagSomalia: FlagSomalia,
  flagBurkinaFaso: FlagBurkinaFaso,
  flagLatvia: FlagLatvia,
  flagSomaliland: FlagSomaliland,
  flagBurundi: FlagBurundi,
  flagLebanon: FlagLebanon,
  flagSouthAfrica: FlagSouthAfrica,
  flagCambodia: FlagCambodia,
  flagLesotho: FlagLesotho,
  flagSouthKorea: FlagSouthKorea,
  flagCameroon: FlagCameroon,
  flagLiberia: FlagLiberia,
  flagSouthSudan: FlagSouthSudan,
  flagCanada: FlagCanada,
  flagLibya: FlagLibya,
  flagSpain: FlagSpain,
  flagCanaryIslands: FlagCanaryIslands,
  flagLiechtenstein: FlagLiechtenstein,
  flagSriLanka: FlagSriLanka,
  flagCapeVerde: FlagCapeVerde,
  flagLithuania: FlagLithuania,
  flagStBarts: FlagStBarts,
  flagCaymanIslands: FlagCaymanIslands,
  flagLuxembourg: FlagLuxembourg,
  flagStLucia: FlagStLucia,
  flagCentralAfricanRepublic: FlagCentralAfricanRepublic,
  flagMacao: FlagMacao,
  flagStVincentAndTheGrenadines: FlagStVincentAndTheGrenadines,
  flagCeuta: FlagCeuta,
  flagMadagascar: FlagMadagascar,
  flagSudan: FlagSudan,
  flagChad: FlagChad,
  flagMadeira: FlagMadeira,
  flagSuriname: FlagSuriname,
  flagChile: FlagChile,
  flagMalawi: FlagMalawi,
  flagSwaziland: FlagSwaziland,
  flagChina: FlagChina,
  flagMalaysia: FlagMalaysia,
  flagSweden: FlagSweden,
  flagCocosIsland: FlagCocosIsland,
  flagMaldives: FlagMaldives,
  flagSwitzerland: FlagSwitzerland,
  flagColombia: FlagColombia,
  flagMali: FlagMali,
  flagSyria: FlagSyria,
  flagComoros: FlagComoros,
  flagMalta: FlagMalta,
  flagTaiwan: FlagTaiwan,
  flagCookIslands: FlagCookIslands,
  flagMarshallIsland: FlagMarshallIsland,
  flagTajikistan: FlagTajikistan,
  flagCorsica: FlagCorsica,
  flagMartinique: FlagMartinique,
  flagTanzania: FlagTanzania,
  flagCostaRica: FlagCostaRica,
  flagMauritania: FlagMauritania,
  flagThailand: FlagThailand,
  flagCroatia: FlagCroatia,
  flagMauritius: FlagMauritius,
  flagTibet: FlagTibet,
  flagCuba: FlagCuba,
  flagMelilla: FlagMelilla,
  flagTogo: FlagTogo,
  flagCuracao: FlagCuracao,
  flagMexico: FlagMexico,
  flagTokelau: FlagTokelau,
  flagCyprus: FlagCyprus,
  flagMicronesia: FlagMicronesia,
  flagTonga: FlagTonga,
  flagCzechRepublic: FlagCzechRepublic,
  flagMoldova: FlagMoldova,
  flagTransnistria: FlagTransnistria,
  flagDemocraticRepublicOfCongo: FlagDemocraticRepublicOfCongo,
  flagMonaco: FlagMonaco,
  flagTrinidadAndTobago: FlagTrinidadAndTobago,
  flagDenmark: FlagDenmark,
  flagMongolia: FlagMongolia,
  flagTunisia: FlagTunisia,
  flagDjibouti: FlagDjibouti,
  flagMontenegro: FlagMontenegro,
  flagTurkey: FlagTurkey,
  flagDominica: FlagDominica,
  flagMontserrat: FlagMontserrat,
  flagTurkmenistan: FlagTurkmenistan,
  flagDominicanRepublic: FlagDominicanRepublic,
  flagMorocco: FlagMorocco,
  flagTurksAndCaicos: FlagTurksAndCaicos,
  flagEastTimor: FlagEastTimor,
  flagMozambique: FlagMozambique,
  flagTuvalu: FlagTuvalu,
  flagEcuador: FlagEcuador,
  flagMyanmar: FlagMyanmar,
  flagUganda: FlagUganda,
  flagEgypt: FlagEgypt,
  flagNamibia: FlagNamibia,
  flagUkraine: FlagUkraine,
  flagElSalvador: FlagElSalvador,
  flagNato: FlagNato,
  flagUnitedArabEmirates: FlagUnitedArabEmirates,
  flagEngland: FlagEngland,
  flagNauru: FlagNauru,
  flagUnitedKingdom: FlagUnitedKingdom,
  flagEquatorialGuinea: FlagEquatorialGuinea,
  flagNepal: FlagNepal,
  flagUnitedNations: FlagUnitedNations,
  flagEritrea: FlagEritrea,
  flagNetherlands: FlagNetherlands,
  flagUnitedStates: FlagUnitedStates,
  flagEstonia: FlagEstonia,
  flagNewZealand: FlagNewZealand,
  flagUruguay: FlagUruguay,
  flagEthiopia: FlagEthiopia,
  flagNicaragua: FlagNicaragua,
  flagUzbekistán: FlagUzbekistán,
  flagEuropeanUnion: FlagEuropeanUnion,
  flagNiger: FlagNiger,
  flagVanuatu: FlagVanuatu,
  flagFalklandIslands: FlagFalklandIslands,
  flagNigeria: FlagNigeria,
  flagVaticanCity: FlagVaticanCity,
  flagFaroeIslands: FlagFaroeIslands,
  flagNiue: FlagNiue,
  flagVenezuela: FlagVenezuela,
  flagFiji: FlagFiji,
  flagNorfolkIsland: FlagNorfolkIsland,
  flagVietnam: FlagVietnam,
  flagFinland: FlagFinland,
  flagNorthKorea: FlagNorthKorea,
  flagVirginIslands: FlagVirginIslands,
  flagFrance: FlagFrance,
  flagNorthernCyprus: FlagNorthernCyprus,
  flagWales: FlagWales,
  flagFrenchPolynesia: FlagFrenchPolynesia,
  flagNorthernMarianasIslands: FlagNorthernMarianasIslands,
  flagYemen: FlagYemen,
  flagGabon: FlagGabon,
  flagNorway: FlagNorway,
  flagZambia: FlagZambia,
  flagGalapagosIslands: FlagGalapagosIslands,
  flagOman: FlagOman,
  flagZimbabwe: FlagZimbabwe,
  flagGambia: FlagGambia,
  flagOrkneyIslands: FlagOrkneyIslands,
};

export const iconComponents = {
  menu: Menu,
  api: API,
  message: Message,
  checkmark: Checkmark,
  checkCircle: CheckCircle,
  minus: Minus,
  'space-dashboard': SpaceDashboard,
  warehouse: Warehouse,
  inbound: Inbound,
  inventory: Inventory2,
  'local-shipping': LocalShipping,
  returns: Returns,
  account: Account,
  'bar-chart': BarChart,
  'account-tree': AccountTree,
  extension: Extension,
  'logo-full-white': LogoFullWhite,
  'logo-full-dark': LogoFullDark,
  'logo-square-dark': LogoSquareDark,
  'logo-square-light': LogoSquareLight,
  'logo-compact': LogoCompact,
  notifications: Notifications,
  settings: Settings,
  moreHoriz: MoreHoriz,
  star: Star,
  'ai-chat': AiChat,
  lightning: Lightning,
  'calendar-today': CalendarToday,
  help: Help,
  'keyboard-tab-left': KeyboardTabToLeft,
  'keyboard-tab-right': KeyboardTabToRight,
  search: Search,
  'accordion-arrow-down': AccordionArrowDown,
  'accordion-arrow-up': AccordionArrowUp,
  download: Download,
  arrowRight: ArrowRight,
  arrowLeft: ArrowLeft,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  openInNew: OpenInNew,
  package: Package,
  warning: Warning,
  bug: Bug,
  arrowUpward: ArrowUpward,
  arrowDownward: ArrowDownward,
  tune: Tune,
  deleteWidget: DeleteWidget,
  dragIndicator: DragIndicator,
  plus: Plus,
  send: Send,
  signPost: SignPost,
  close: Close,
  company: Company,
  profile: Profile,
  public: Public,
  channels: Channels,
  conditions: Conditions,
  logOut: LogOut,
  deleteCircle: DeleteCircle,
  edit: Edit,
  notificationsActive: NotificationsActive,
  duplicate: Duplicate,
  starFilled: StarFilled,
  delete: Delete,
  starDark: StarDark,
  starDarkFilled: StarDarkFilled,
  variable: Variable,
  bold: Bold,
  italic: Italic,
  underline: Underline,
  google: Google,
  apple: Apple,
  error: Error,
  store: Store,
  fedex: Fedex,
  ups: Ups,
  dhl: Dhl,
  gls: Gls,
  myProfile: MyProfile,
  lock: Lock,
  'lock-filled': LockFilled,
  eye: Eye,
  visibilityOff: VisibilityOff,
  link: Link,
  integrations: Integrations,
  imageUpload: ImageUpload,
  infoCircle: InfoCircle,
  attachFile: AttachFile,
  pin: Pin,
  facebook: Facebook,
  linkedin: LinkedIn,
  x: X,
  file: File,
  pallet: Pallet,
  note: Note,
  folderOpen: FolderOpen,
  accountCircle: AccountCircle,
  labelImportant: LabelImportant,
  ...iconFlags,
  chat: Chat,
  'cloud-download': CloudDownload,
  chevronDown: ChevronDown,
  runImport: RunImport,
  info: Info,
  infoOutlined: InfoOutlined,
  warning_filled: WarningFilled,
};

const getIcon = (name: IconName, width?: number, height?: number, extraProps?: Record<string, any>) => {
  const IconComponent = iconComponents[name];
  if (!IconComponent) return null;

  const iconProps = {
    ...(width && height ? { width, height } : { width: 20, height: 20 }),
    ...extraProps,
  };

  return <IconComponent {...iconProps} />;
};

const Icon: React.FC<IconProps> = ({ className, color, name, iconRef, width, height, onClick, hoverText = null }) => {
  const icon = getIcon(name, width, height);
  if (!icon) return null;

  const fillClass = color ? `fill-${color}` : '';
  const clickable = Boolean(onClick);

  const interactiveProps = onClick
    ? {
        role: 'button',
        tabIndex: 0,
        onClick,
        onKeyDown: (e: React.KeyboardEvent<HTMLSpanElement>) => {
          if (e.key === 'Enter' || e.key === ' ') onClick(e as unknown as React.MouseEvent<HTMLSpanElement>);
        },
      }
    : {};

  const iconElement = (
    <i
      ref={iconRef}
      {...interactiveProps}
      className={`
        ${fillClass}
        ${className || ''}
        ${clickable ? 'cursor-pointer' : ''}
      `}>
      {icon}
    </i>
  );

  if (!hoverText) {
    return iconElement;
  }

  return (
    <MuiTooltip title={hoverText} arrow>
      <span className="inline-flex">{iconElement}</span>
    </MuiTooltip>
  );
};

export default Icon;
